import React from 'react'
import PropTypes from 'prop-types'

function TableScrollContainer ({ selectable, children }) {
  const classNames = [
    'w-full overflow-x-auto text-sm',
    selectable ? 'selectable' : null
  ].filter(e => e)

  return (
    <div className={classNames.join(' ')}>
      {children}
    </div>
  )
}

TableScrollContainer.defaultProps = {
  selectable: false
}

TableScrollContainer.propTypes = {
  /**
   * If table rows can be selected/interacted with
   */
  selectable: PropTypes.bool
}

export default TableScrollContainer
